module.exports = __webpack_public_path__ + "img/TCA.04187456.svg";